import Vue from 'vue'
import Router from 'vue-router'
import loginPage from '@/content/login/login_page.vue'
import indexPage from '@/content/index_page.vue'
import downloadPage from '@/content/mobile/download_page.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes:[
    {
      path: '/',
      name: 'indexPage',
      component: indexPage
    },
    {
      path: '/login',
      name: 'loginPage',
      component: loginPage
    },
    {
      path: '/download',
      name: 'downloadPage',
      component: downloadPage
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js